import React from 'react'
import ReactRailsUJS from 'react_ujs'

export default function PluginSlot({ component, props }) {
  const Comp = ReactRailsUJS.getConstructor(component)
  return Comp ? <Comp {...(props || {})} /> : null
}
